(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.directive('helpCategory', ['$rootScope', '$uibModal', '$state', 'HelpService', HelpCategoryFn]);

    /* help category directive */
    function HelpCategoryFn($rootScope, $uibModal, $state, HelpService) {

        var directive = {
            restrict: 'E',
            link: link,
            replace: true,
            templateUrl: '/app/help/templates/help-category.template.html',
            scope: {
                category: '=',
                items: '=',
                searchval: '=',
                showEdit: '@'
            }
        };
        return directive;

        function link(scope) {

            activate();

            // open detail view
            scope.open = function (selectedHelpCategory) {

                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    animation: true,
                    templateUrl: '/app/help/templates/help-detail.template.html',
                    controller: 'HelpDetailController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        // load helpcategories
                        helpCategory: function () {
                            return selectedHelpCategory;
                        },
                        // load languages
                        languages: ['AdministrationService', function (AdministrationService) {
                            return AdministrationService.languages();
                        }],
                        // load helplist
                        helpList: ['HelpService', function (HelpService) {
                            return HelpService.query(selectedHelpCategory.value);
                        }]
                    }
                });

                // when modal is closed
                modalInstance.result.then(function (item) {

                    // reload view
                    $state.go($state.current.name, null, { reload: $state.current.name });

                }, function () {
                    //dismissed
                });
            };

            // load content of item
            scope.load = function (help) {
                HelpService.get(help.id).then(function (result) {
                    var i = 0;
                    var len = scope.list.length;
                    for (i; i < len; i++) {
                        if (scope.list[i].id === help.id) {
                            scope.list[i] = result;
                            break;
                        }
                    }
                });
            };

            // prepare list
            function prepare() {
                // only show items of category
                scope.list = [];
                var i = 0;
                var len = scope.items ? scope.items.length : 0;
                // check searchval ?
                var check = scope.searchval && scope.searchval !== null && scope.searchval.length > 0;
                for (i; i < len; i++) {
                    if (scope.items[i].category === scope.category.value) {
                        // search-value existing ?
                        if (check && scope.items[i].content !== null) {
                            if (scope.items[i].content.includes(scope.searchval)) {
                                scope.list.push(scope.items[i]);
                            } // if
                        } // if
                        else {
                            scope.list.push(scope.items[i]);
                        }
                    }
                }
            }

            // do activation work
            function activate() {
                // prepare list
                prepare();

                // set is ringfoonadmin
                scope.canShowEdit = scope.showEdit !== undefined && scope.showEdit === 'true' && $rootScope.isRingfoonAdmin;

                scope.$watch(function () { return scope.searchval; }, function (newval, oldval) {
                    if (newval === oldval) { return; }
                    prepare();
                });

            }
        }
    }

})();